import {
  Typography,
  styled,
  Button,
  Dialog,
  Box,
  IconButton,
  ButtonBase,
  TooltipProps,
  Tooltip,
  tooltipClasses,
} from '@mui/material';

export const OutlinedButton = styled(Button)(({ theme }) => ({
  maxWidth: '140px',
  height: '40px',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    maxWidth: '800px',
    borderRadius: 16,
    backgroundColor: '#FAFCFF',
  },
}));

export const DialogContainer = styled(Box)(() => ({
  minWidth: 700,
  minHeight: 200,
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
}));

export const TextTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignContent: 'center',
  span: {
    color: theme.palette.secondary.main,
  },
}));

export const DownloadButton = styled(IconButton)(({ theme }) => ({
  span: {
    color: theme.palette.primary.main,
  },
  '&:disabled': {
    span: {
      filter: 'opacity(45%)',
    },
  },
}));

export const ActionButton = styled(ButtonBase)(({ theme }) => ({
  color: theme.palette.primary.main,
  textAlign: 'justify',
  fontSize: '16px',
  span: {
    width: 250,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '&:disabled': {
    span: {
      filter: 'opacity(45%)',
    },
  },
}));

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    textAlign: 'justify',
    fontSize: '12px',
    padding: '8px',
    fontWeight: 'normal',
    border: '1px solid #dadde9',
    boxShadow: '0px 3px 6px #00000029',
    marginTop: '8px !important',
  },
}));

export const CloseButtonBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
}));

export const CloseIcon = styled(IconButton)(({ theme }) => ({
  margin: '20px 20px -50px 0',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));
